export const OrderCompleteModalTestIds = {
  modal: "orderConfirmModal",
  deliveryConfirmation: "deliveryConfirmation",
  pickupConfirmation: "pickupConfirmation",
};
